import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "../store"

export const isEnabled = (state: RootState) => state.demoSlice.enabled

export const selectIsEnabled = createSelector([isEnabled], isEnabled => ({
  isEnabled,
}))
